
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoReviewsItemImages',
  mixins: [respUtility],
  props: {
    images: {
      type: Array,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    },
    view3D: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showPopup: false,
      indexTabPopup: 0,
      indexSliderPopup: 0,
    };
  },
  methods: {
    openPopup(index, tab) {
      this.indexTabPopup = tab;
      this.indexSliderPopup = index;
      this.showPopup = true;
      this.$nuxt.$emit('change-global-scrolling', !this.showPopup);
      document.addEventListener('keydown', this.handleEsc);
    },
    changeIndexSliderPopup(value) {
      this.indexSliderPopup = value;
    },
    closePopup() {
      this.showPopup = false;
      this.$nuxt.$emit('change-global-scrolling', !this.showPopup);
      document.removeEventListener('keydown', this.handleEsc);
    },
    handleEsc(event) {
      if (this.showPopup && event.key === 'Escape' && event.keyCode === 27) {
        this.closePopup();
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEsc);
  },
};
